// extracted by mini-css-extract-plugin
export var actions = "_7-4";
export var brand = "_7-3";
export var header = "_7-0";
export var headerContent = "_7-1";
export var identity = "_7-5";
export var logo = "_7-2";